import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/CustomToggleSwitch";

export default function GantChartSwitch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const isChecked = searchParams.get("GantChart") === "true"; // Ensure it works with boolean value

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value.toString()); // Convert boolean to string
    setSearchParams(newSearchParams);
  };
  const handleToggle = (newStatus, e) => {
    e.stopPropagation();

    updateSearchParams("GantChart", newStatus);
  };
  return (
    <div className="gant-chart-switch">
      <CustomToggleSwitch
        initialStatus={isChecked}
        onToggle={(newStatus, e) => handleToggle(newStatus, e)}
        label="Gantt View"
        iconSrc=""
        customClass="related_time"
      />
    </div>
  );
}
